import React from 'react'
import '../../Styles/App.css';

export default function Section2() {
    return (
        <div className='min-h-screen py-10 flex items-center justify-center bg-[#0E081B]/30'>
            <div className='w-[90%]'>
                <div className='flex justify-center'>
                    <button className='px-10 py-2 rounded-full font-bold border border-white bg-black text-[#A880FF]'>
                        FEATURES
                    </button>
                </div>
                <div className='relative'>
                <h1 className='mt-5 text-center text-2xl lg:text-4xl 2xl:text-5xl font-medium'>Your Game, Your Edge</h1>
                <p className='capitalize text-center mt-3'>Empowering Players, Elevating Clubs, and Engaging Fans—because football is more than a game, it’s a revolution!</p>
                </div>
                <div className='flex flex-col lg:flex-row justify-around gap-10 mt-5'>
                    <div className='grid content-around w-[100%] lg:w-[25%] 2xl:w-[23%]' data-aos='flip-left' data-aos-duration='2000'>
                        <div className='border-[#2F1073] border-[2px] p-1 rounded-[50px] mb-5 overflow-hidden relative'>
                            <div className='persona-gradient animate-spin-slow'></div>
                            <div className='h-[350px] overflow-hidden bg-[#07030e] rounded-[50px]'>
                                <img src='/assets/others/sec2_1.svg' className='h-full w-full object-cover'></img>
                            </div>
                        </div>
                        <h1 className='text-center font-bold uppercase text-xl'>Player </h1>
                        <p className='text-center'>Elevate your game with precision health insights, and showcase your skills </p>
                        <div className='flex justify-center mt-3'>
                            <button className='px-5 py-2 rounded-full border-[2px] font-bold flex items-center gap-2 cursor-pointer'><span>GET STARTED </span><img src='/assets/icon/magic.svg'></img></button>
                        </div>
                    </div>
                    <div className='grid content-around w-[100%] lg:w-[25%] 2xl:w-[23%]' data-aos='flip-left' data-aos-duration='2500'>
                        <div className='border-[#2F1073] border-[2px] p-1 rounded-[50px] mb-5 overflow-hidden relative'>
                            <div className='persona-gradient-2 animate-spin-slow'></div>
                            <div className='h-[350px] overflow-hidden bg-[#07030e] rounded-[50px]'>
                                <img src='/assets/others/sec2_2.svg' className='h-full w-full object-cover'></img>
                            </div>
                        </div>
                        <h1 className='text-center font-bold uppercase text-xl'>CLUB’S</h1>
                        <p className='text-center'>Discover untapped talent, optimize player development with genomic insights & streamline recruitment. </p>
                        <div className='flex justify-center mt-3'>
                            <button className='px-5 py-2 rounded-full border-[2px] font-bold flex items-center gap-2 cursor-pointer'><span>GET STARTED </span><img src='/assets/icon/magic.svg'></img></button>
                        </div>
                    </div>
                    <div className='grid content-around w-[100%] lg:w-[25%] 2xl:w-[23%]' data-aos='flip-left' data-aos-duration='3000'>
                        <div className='border-[#2F1073] border-[2px] p-1 rounded-[50px] mb-5 overflow-hidden relative'>
                            <div className='persona-gradient-3 animate-spin-slow'></div>
                            <div className='h-[350px] overflow-hidden bg-[#07030e] rounded-[50px]'>
                                <img src='/assets/others/sec2_3.svg' className='h-full w-full object-cover'></img>
                            </div>
                        </div>
                        <h1 className='text-center font-bold uppercase text-xl'>FAN’S</h1>
                        <p className='text-center'>Access exclusive NFTs, support players, and shape soccer’s future in club campaigns.</p>
                        <div className='flex justify-center mt-3'>
                            <button className='px-5 py-2 rounded-full border-[2px] font-bold flex items-center gap-2 cursor-pointer'><span>GET STARTED </span><img src='/assets/icon/magic.svg'></img></button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
